import { serverNodeApiUrl } from "../index";

// Layer 1: Update Host URLs
export const updateHostUrls = async () => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/update-host-urls`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in updateHostUrls API call:", error);
        throw error;
    }
};

// Layer 2: Copy Prompts
export const copyPrompts = async () => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/copy-prompts`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in copyPrompts API call:", error);
        throw error;
    }
};

// Layer 3: Clear Cache
export const clearCache = async () => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/clear-cache`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in clearCache API call:", error);
        throw error;
    }
};
export const getClearCache = async () => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/clear-cache`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in getClearCache API call:", error);
        throw error;
    }
};

// Layer 4: Merge Categories
export const mergeCategories = async (sourceSubCategoryId, targetSubCategoryId) => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/merge-categories`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ sourceSubCategoryId, targetSubCategoryId }),
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in mergeCategories API call:", error);
        throw error;
    }
};

// Layer 5: Fix Test Information and Result Page
export const testInformationAndResultPageFix = async () => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/fix-test-information`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in testInformationAndResultPageFix API call:", error);
        throw error;
    }
};

// Layer 6: Update Test Marks
export const updateTestMarks = async (posMarks, negMarks) => {
    try {
        const response = await fetch(`${serverNodeApiUrl}testseries/admin/troubleshoot/testseries/update-marks`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                testSeriesId: 1, // Hardcoded as requested
                posMarks,
                negMarks
            }),
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in updateTestMarks API call:", error);
        throw error;
    }
};